import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
{/* <div id='congra'><FadeIn delay={timeToLoad*1000} transitionDuration={1000} className='smallTimer'>Congratulations</FadeIn></div> */}